import React, { useCallback } from "react";
import { Button } from "@trailhead/asurion-ui";
import { ButtonType } from "../../types";

import { trackEvent } from "@trailhead/analytics";

export const CardCallBtn = (props: ButtonType): JSX.Element => {
    const { text, link, eventName } = props;

    const onClick = useCallback(() => {
        if (!!eventName) {
            trackEvent(eventName || "", {
                link,
            });
        }
        window.open(link, "_self"); // open for both desktop and mobile for now
    }, [eventName, link]);

    return (
        <Button color="secondary" size="small" onClick={onClick}>
            {text}
        </Button>
    )
}